import { Injectable } from '@angular/core';
import { connectScreenShareResolution } from '@epicuro-next/platform/configuration';
import { from, Observable } from 'rxjs';

// This is a known issue in typescript
// https://github.com/microsoft/TypeScript/issues/33232
// Typescript implementation does not implement it yet
declare var navigator: Navigator & {
  mediaDevices: MediaDevices & {
    getDisplayMedia(constraints?: MediaStreamConstraints): Promise<MediaStream>;
  };
};

@Injectable()
export class ConnectPermissionsService {
  public devices: MediaDeviceInfo[];

  public async ensureMediaPermissions() {
    return new Promise(async (resolve, reject) => {
      try {
        this.devices = await this.getDevices();
        const hasMediaAccess = this.devices.every(
          (device) => device.deviceId && device.label,
        );
        if (!hasMediaAccess) {
          const stream = await this.acquireUserMedia();
          stream.getTracks().forEach((track) => track.stop());
        }
        resolve(undefined);
      } catch (error) {
        reject();
      }
    });
  }

  public acquireDisplayMediaTrack(): Observable<MediaStream> {
    return from(this.acquireDisplayMedia());
  }

  public getDevices() {
    return navigator.mediaDevices.enumerateDevices();
  }

  private acquireUserMedia() {
    return navigator.mediaDevices.getUserMedia({
      video: true,
      audio: true,
    });
  }

  private acquireDisplayMedia() {
    return navigator.mediaDevices.getDisplayMedia({
      video: connectScreenShareResolution,
    });
  }
}
